<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入分拣框">
      <el-button :disabled="!pkgCode" slot="customize" type="primary" @click="finish">
        打印
      </el-button>
    </ScanQuery>
    <div style="text-align: left;margin-bottom: 10px;">
      分拣框中组合组数：<span style="font-size: 30px;color:red">{{ totalNum }}</span>
      <span style="margin-left: 30px;">体积：</span>
      <el-radio-group v-model="volume" :disabled="hasVolume">
        <div style="text-align: left">
          <el-radio-button label="XS">超小</el-radio-button>
          <el-radio-button label="S">小</el-radio-button>
          <el-radio-button label="M">中</el-radio-button>
          <el-radio-button label="L">大</el-radio-button>
          <el-radio-button label="XL">超大</el-radio-button>
        </div>
      </el-radio-group>
    </div>
    <el-card style="margin-bottom: 10px">
      <WmsTable :hasHeader="false" :columns="columns" :dataSource="dataSource" :scrollY="300" :isPagination="false">
        <template #productImg="{ text, record }">
          <ImgPreviews :images="[text]"></ImgPreviews>
        </template>
        <template #addtions="{ text, record }">
          <el-space>
            <el-tag type="info" style="margin-right: 5px;margin-bottom: 5px;"
              v-for="item in (record.additionalList || [])" :key="item.additionName + '-' + item.ingredientsSku">{{
                item.additionName }}</el-tag>
            <a href="#" @click.prevent="showAdditionDetail(record)">查看详情</a>
          </el-space>
        </template>
      </WmsTable>
    </el-card>

    <el-drawer :visible.sync="detailDrawerVisible" direction="rtl" size="60%" title="附加项详情"
      custom-class="additional-detail-drawer" append-to-body>
      <div class="additional-drawer">
        <!-- <div class="additional-drawer-header">
          <h2>附加项详情</h2>
          <button class="additional-drawer-close" type="button" aria-label="关闭"
            @click="detailDrawerVisible = false">
            <i class="el-icon-close"></i>
          </button>
        </div> -->
        <div class="additional-drawer-body">
          <div class="additional-drawer-sku">
            <span>SKU:</span>
            <strong>{{ detailShopProductSku || "-" }}</strong>
          </div>
          <div class="additional-drawer-subtitle">当前 SKU 下的附加项辅料</div>
          <el-table :data="additionDetailList" border class="additional-detail-table" v-loading="detailLoading"
            empty-text="当前附加项暂无辅料">
            <el-table-column label="附加项名称" prop="additionName" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.additionName || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="辅料名称" prop="ingredientsName" min-width="240">
              <template slot-scope="scope">
                {{ scope.row.ingredientsName || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="辅料图片" prop="ingredientsImg" width="160" align="center">
              <template slot-scope="scope">
                <ImgPreviews v-if="scope.row.ingredientsImg" :images="[scope.row.ingredientsImg]" :width="60"
                  :height="60" />
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="辅料库位" prop="gridCode" min-width="220">
              <template slot-scope="scope">
                {{ scope.row.gridCode || "-" }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>

    <div style="display: flex; justify-content: space-between; width: 100%">
      <el-card style="flex-grow: 1">
        <div slot="header" style="text-align: left">
          <span>附加项</span>
        </div>
        <el-table :data="additionList" height="300px" border style="width: 100%">
          <el-table-column label="附加项名称" prop="additionName">
            <template slot-scope="scope">
              {{ scope.row.additionName || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="辅料名称" prop="ingredientsName">
            <template slot-scope="scope">
              {{ scope.row.ingredientsName || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="辅料图片" prop="ingredientsImg">
            <template slot-scope="scope">
              <ImgPreviews :images="[scope.row.ingredientsImg]" :width="100" :height="100"
                v-if="scope.row.ingredientsImg" />
              <span v-if="!scope.row.ingredientsImg">-</span>
            </template>
          </el-table-column>
          <el-table-column label="辅料库位" prop="gridCode">
            <template slot-scope="scope">
              {{ scope.row.gridCode || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card style="margin-left: 10px; flex-shrink: 0; width: 50%" v-if="basketVOList && basketVOList.length">
        <div slot="header" style="text-align: left">
          <span>同组合商品分拣框</span>
        </div>
        <div style="width: 100%" class="boxBlock">
          <div v-for="i in basketVOList" :key="i.basketCode" class="boxItem" :style="`background-color: ${i.useStatus == 0 ? '#d9d9d9' : '#048060'
            };`">
            {{ i.basketCode }}
          </div>
          <!-- <div class="boxItem" style="background-color: #048060;">篮子编号:LZ0003</div>
          <div class="boxItem" style="background-color: #048060;">篮子编号:LZ0004</div>
          <div class="boxItem" style="background-color: #048060;">篮子编号:LZ0005</div>
          <div class="boxItem" style="background-color: #048060;">篮子编号:LZ0006</div>
          <div class="boxItem" style="background-color: #d9d9d9;">篮子编号:LZ0007</div> -->
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews";
import { columns } from "./data";
import { getBasketInfo, doBasketPackFinish } from "@/apis/combination";
import { getIngredientsBatch } from "@/apis/checking";
import { pkgDetail } from "@/apis/outStock";

export default {
  name: "combination",
  components: { ScanQuery, WmsTable, ImgPreviews },
  data() {
    return {
      columns,
      query: {
        code: "",
      },
      totalNum: 0,
      dataSource: [],
      additionList: [],
      basketVOList: [],
      showBoxBlock: true,
      pkgCode: "",
      basketCode: "",
      packCode: "",
      volume: '',
      hasVolume: false,
      // 附加项详情抽屉的显示状态。
      detailDrawerVisible: false,
      // 当前详情抽屉展示的商品 SKU。
      detailShopProductSku: '',
      // 当前详情抽屉展示的附加项列表。
      additionDetailList: [],
      // 当前辅料库位查询的加载状态。
      detailLoading: false
    };
  },
  computed: {},
  methods: {
    // 打开附加项详情抽屉，并查询当前商品附加项对应的辅料库位。
    showAdditionDetail(record) {
      // 当前点击记录中的全部附加项列表。
      const additionalList = Array.isArray(record?.additionalList) ? record.additionalList : [];
      // 当前附加项中需要查询库位的辅料 SKU 数组。
      const ingredientsSku = additionalList
        .map((item) => item.ingredientsSku)
        .filter(Boolean)
        .filter((sku, index, list) => list.indexOf(sku) === index);

      // 当前点击记录对应的商品 SKU。
      this.detailShopProductSku = record?.shopProductSku || '';
      this.detailDrawerVisible = true;
      this.detailLoading = ingredientsSku.length > 0;
      // 先清空旧数据，避免切换记录时短暂显示上一条详情。
      this.additionDetailList = [];

      if (!ingredientsSku.length) {
        // 没有辅料 SKU 时无需请求库位接口，直接展示全部附加项。
        this.additionDetailList = additionalList.map((item) => ({
          ...item,
          gridCode: '-',
          ingredientsName: '-',
          ingredientsImg: '',
        }));
        this.detailLoading = false;
        return;
      }

      // 辅料库位接口返回的状态码和库位列表。
      getIngredientsBatch(ingredientsSku).then(({ code, data }) => {
        if (code !== 0 || !Array.isArray(data)) {
          // 接口返回异常时保留附加项基础信息，并用短横线表示未知库位。
          this.additionDetailList = additionalList.map((item) => ({
            ...item,
            gridCode: item.ingredientsSku ? (item.gridCode || '-') : '-',
            ingredientsName: item.ingredientsSku ? (item.ingredientsName || '-') : '-',
            ingredientsImg: item.ingredientsSku ? (item.ingredientsImg || '') : '',
          }));
          return;
        }

        // 将接口返回的辅料库位按辅料 SKU 建立索引，避免逐行重复筛选。
        const gridMap = data.reduce((map, item) => {
          if (item.ingredientsSku) {
            map[item.ingredientsSku] = item.gridCode || '-';
          }
          return map;
        }, {});

        // 将库位信息合并到当前抽屉列表，同时保留附加项名称和图片。
        this.additionDetailList = additionalList.map((item) => ({
          ...item,
          gridCode: item.ingredientsSku ? (gridMap[item.ingredientsSku] || item.gridCode || '-') : '-',
          ingredientsName: item.ingredientsSku ? (item.ingredientsName || '-') : '-',
          ingredientsImg: item.ingredientsSku ? (item.ingredientsImg || '') : '',
        }));
      }).catch(() => {
        // 请求失败时保留基础信息，并提示用户库位暂不可用。
        this.additionDetailList = additionalList.map((item) => ({
          ...item,
          gridCode: item.ingredientsSku ? (item.gridCode || '-') : '-',
          ingredientsName: item.ingredientsSku ? (item.ingredientsName || '-') : '-',
          ingredientsImg: item.ingredientsSku ? (item.ingredientsImg || '') : '',
        }));
        this.$message.error('辅料库位查询失败');
      }).finally(() => {
        // 无论请求成功或失败，都结束详情加载状态。
        this.detailLoading = false;
      });
    },
    queryCall: function (payload) {
      if (payload.code) {
        this.getDetail(payload.code);
      }
    },
    getDetail(basketCode) {
      getBasketInfo({ basketCode: basketCode }).then(({ code, data }) => {
        if (code == 0) {
          this.dataSource = data.packItemVOList;
          this.totalNum = data.totalNums;
          this.basketVOList = data.basketVOList;
          this.basketCode = basketCode;
          this.packCode = data.packCode;
          this.pkgCode = data.pkgCode;
          this.volume = data.volume || ''
          this.hasVolume = !!data.volume
          // 当前分拣框顶部附加项列表，接口缺少该字段时按空数组处理。
          const additionalList = Array.isArray(data.additionalList) ? data.additionalList : [];
          // 顶部附加项中需要查询库位的辅料 SKU 数组。
          const ingredientsSku = [];
          additionalList.forEach((item) => {
            if (item.ingredientsSku) {
              ingredientsSku.push(item.ingredientsSku);
            }
          });
          if (ingredientsSku.length) {
            getIngredientsBatch(ingredientsSku).then((res) => {
              // 将顶部附加项对应的库位合并到旧版附加项表格。
              // 顶部库位接口返回的辅料库位列表。
              const ingredientBatchList = Array.isArray(res.data) ? res.data : [];
              // 将顶部辅料库位列表按辅料 SKU 建立索引。
              const gridMap = ingredientBatchList.reduce((map, item) => {
                map[item.ingredientsSku] = item.gridCode;
                return map;
              }, {});
              this.additionList = additionalList.map((item) => ({
                ...item,
                gridCode: gridMap[item.ingredientsSku] || item.gridCode || '-'
              }));
            });
          } else {
            this.additionList = additionalList;
          }
        }
      });
    },
    finish() {
      if (!this.volume) {
        this.$message.warning("请选择体积");
        return
      }
      doBasketPackFinish({
        basketCode: this.basketCode,
        packCode: this.packCode,
        volume: this.volume
      }).then(({ code }) => {
        if (code == 0) {
          this.$message.success("成功");
          let Arr = [{ pkgCode: this.pkgCode }];
          this.$wmsPrint.print().templatePrintByPkg(Arr);
          this.resetPage();
          // pkgDetail({pkgCode:this.pkgCode}).then(({code,data})=>{
          //   if(code == 0){
          //     this.$printPkg(1, data.systemSource, Arr).catch(res => {
          //       this.$wmsPrint.print().templatePrintByPkg(Arr);
          //     })
          //   }else{
          //     this.$wmsPrint.print().templatePrintByPkg(Arr);
          //   }
          // })
        }
      });
    },
    resetPage() {
      this.dataSource = [];
      this.additionList = [];
      this.basketVOList = [];
      this.pkgCode = "";
      this.basketCode = "";
      this.packCode = "";
      this.totalNum = 0;
      this.volume = "";
      this.hasVolume = false;
      this.detailDrawerVisible = false;
      this.detailShopProductSku = "";
      this.additionDetailList = [];
      this.detailLoading = false;
    },
  },
  mounted() { }
};
</script>

<style scoped>
.boxBlock {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.boxItem {
  padding: 0 10px;
  height: 60px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 22px;
  margin: 5px 5px 0 0;
}
</style>

<style>
.additional-detail-drawer .el-drawer__body {
  padding: 0;
}

.additional-detail-drawer .additional-drawer {
  min-height: 100%;
  color: #606266;
  background: #ffffff;
}

.additional-detail-drawer .additional-drawer-header {
  height: 64px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}

.additional-detail-drawer .additional-drawer-header h2 {
  margin: 0;
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}


.additional-detail-drawer .additional-drawer-close:hover {
  color: #409eff;
}

.additional-detail-drawer .additional-drawer-body {
  padding: 24px;
  box-sizing: border-box;
}

.additional-detail-drawer .additional-drawer-sku {
  display: flex;
  align-items: baseline;
  gap: 8px;
  color: #409eff;
  font-size: 16px;
  font-weight: 600;
}

.additional-detail-drawer .additional-drawer-sku strong {
  color: #409eff;
  font-size: 18px;
}

.additional-detail-drawer .additional-drawer-subtitle {
  margin-top: 8px;
  color: #909399;
  font-size: 14px;
}

.additional-detail-drawer .additional-detail-table {
  width: 100%;
  margin-top: 16px;
  background: #ffffff;
}

.additional-detail-drawer .additional-detail-table th {
  height: 48px;
  color: #606266;
  background: #f2f4f7;
  font-weight: 600;
}

.additional-detail-drawer .additional-detail-table td {
  height: 82px;
  color: #606266;
}

@media (max-width: 768px) {
  .additional-detail-drawer {
    width: 100% !important;
  }

  .additional-detail-drawer .additional-drawer-body {
    padding: 16px;
  }
}
</style>
